import Vue from 'vue'
import userActionTypes from './modules/user/user.type'
import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import DebugActionType from '@/store/modules/debugger/debugger.type'
// naming convention
// raw name mean set, LOADING => mean set LOADING

// user store
const userActionTypesShortcut = { ...userActionTypes }

Object.keys(userActionTypes).forEach(item => {
    userActionTypesShortcut[item] = 'user/' + userActionTypes[item]
})

// scenario store
const ScenarioActionTypeShortcut = { ...ScenarioActionType }

Object.keys(ScenarioActionType).forEach(item => {
    ScenarioActionTypeShortcut[item] = 'scenario/' + ScenarioActionType[item]
})

// canvas store
const DebugActionTypeShortcut = { ...DebugActionType }

Object.keys(DebugActionType).forEach(item => {
    DebugActionTypeShortcut[item] = 'debug/' + DebugActionType[item]
})

// main store
const actionTypes = {
    // common for both action and mutation in main store
    LOADING: 'LOADING',
    TOGGLE_NAVIGATION: 'TOGGLE_NAVIGATION',
    NAVIGATION: 'NAVIGATION',
    TOKEN: 'TOKEN',
    BOT: 'BOT',
    BOT_LIST: 'BOT_LIST',
    OPEN_ID_CONFIG: 'OPEN_ID_CONFIG',
    user: userActionTypesShortcut,
    scenario: ScenarioActionTypeShortcut,
    debug: DebugActionTypeShortcut
}

Vue.prototype.$actionTypes = actionTypes
Vue.prototype.$at = actionTypes

export {
    userActionTypes,
    actionTypes
}
